<div id="top-menu">
  <img *ngIf="currentProp" [src]="img" id="img-full">
  <img [src]="profileImg" id="img" class="user-avatar">
  <p class="main-text">{{currentProp ? currentProp.name : userDisplayName}}</p>
  <p class="text">{{currentProp ? (subtitle | translate) : user.email}}</p>
</div>
<app-main-menu-list></app-main-menu-list>
